
import { Options, Vue } from 'vue-class-component'
import liveMatchScheduleList from '@/components/Frontend/LiveMatchScheduleList/index.vue'

@Options({
  components: {
    liveMatchScheduleList
  }
})

export default class LiveMatchScheduleListView extends Vue {}
